import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { cn } from '@/lib/utils';
import { log } from '@/lib/logger';

interface SelectionCardProps {
  label: string;
  description?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function SelectionCard({ label, description, selected, disabled, onClick }: SelectionCardProps) {
  log.info('[SelectionCard] render', { label, selected, disabled });

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        log.info('[SelectionCard] clicked', { label });
        onClick();
      }}
      className={cn(
        'w-full flex items-center justify-between rounded-xl border px-5 py-4 text-left transition-all duration-150 cursor-pointer',
        !disabled && 'hover:border-primary-300 hover:bg-primary-50/50',
        disabled && 'opacity-50 cursor-not-allowed',
        selected
          ? 'border-primary-500 bg-primary-50'
          : 'border-gray-200 bg-white'
      )}
    >
      <div className="flex-1 min-w-0">
        <span
          className={cn(
            'block text-base font-medium',
            selected ? 'text-primary-700' : 'text-gray-900'
          )}
        >
          {label}
        </span>
        {description && (
          <span className="block mt-1 text-sm text-gray-500">{description}</span>
        )}
      </div>
      <HugeiconsIcon
        icon={ArrowRight01Icon}
        size={20}
        strokeWidth={2}
        color="currentColor"
        className={cn(
          'ml-3 h-5 w-5 flex-shrink-0',
          selected ? 'text-primary-500' : 'text-gray-400'
        )}
      />
    </button>
  );
}
